<template>
    <div>
        <app-note :title="$t('warning')" :notes="$t('invoice_setting_warning_note')"></app-note>
        <app-overlay-loader v-if="preloader"/>
        <form v-else ref="form"  data-url="/invoice/settings" enctype="multipart/form-data"
              class="mb-0 mt-3"
              :class="{'loading-opacity': preloader}">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group row">
                        <label for="invoiceLogo" class="col-lg-3 mb-lg-0">
                            {{ $t('invoice_logo') }} <br>
                            <small class="text-muted font-italic">
                                ({{ $t('recommended_product_size') }})
                            </small>
                        </label>
                        <div class="col-lg-8">
                            <app-input
                                id="invoiceLogo"
                                type="custom-file-upload"
                                v-model="formData.invoice_logo"
                                :label="$t('change_logo')"
                                :generate-file-url="false"
                                @change="changeImage"
                                :error-message="$errorMessage(errors, 'invoice_logo')"
                            />
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="invoiceStartingNumber" class="col-lg-3 mb-lg-0">
                            {{ $t('invoice_starting_number') }}<br>
                        </label>
                        <div class="col-lg-8">
                            <app-input
                                id="invoiceStartingNumber"
                                type="number"
                                v-model="formData.invoice_starting_number"
                                :error-message="$errorMessage(errors, 'invoice_starting_number')"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-5 action-buttons" v-if="$can('manage_invoice_setting')">
                <button class="btn btn-primary mr-2" @click.prevent="submit">
                    {{ $t('save') }}
                </button>
            </div>

        </form>
    </div>
</template>

<script>
import {FormMixin} from '../../../../core/mixins/form/FormMixin';
import {formDataAssigner} from "../../../Helpers/Helpers";
import {urlGenerator} from "../../../Helpers/AxiosHelper";

export default {
    name: 'InvoiceSetting',
    mixins: [FormMixin],
    data() {
        return {
            editorShow: false,
            preloader: false,
            isImageChange: false,
            errors: {},
            formData: {
                invoice_logo: '',
                invoice_starting_number: '',
            }
        }
    },
    methods: {
        changeImage() {
            this.isImageChange = true;
        },
        afterError(response) {
            this.errors = response.data.errors;
        },
        submit() {
            let formData = formDataAssigner(new FormData, this.formData);
            if (!this.isImageChange) {
                formData.append('invoice_logo', this.formData.invoice_logo);
            }
            this.save(formData)
        },
        afterSuccess(res) {
            this.$toastr.s(res.data.message);
        },
        getInvoiceData() {
            this.preloader = true;
            this.axiosGet(`get-basic-setting-data`).then(({data}) => {
                this.formData = data;
                this.formData.invoice_logo = urlGenerator(data.invoice_logo);
            }).finally(() => {
                this.preloader = false;
            })
        }
    },
    created() {
        this.getInvoiceData();
    }
}
</script>